import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, unref as _unref, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "conversation-accordion__header" };
const _hoisted_2 = ["aria-label", "onKeydown"];
import { ref, watch, nextTick, onMounted, onUnmounted } from "vue";
import RecAccordion from "@/common/components/RecAccordion.vue";
import SummaryContent from "../components/SummaryContent.vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { vTooltip } from "@/common/directives/tip-directive";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SummaryBlock',
    props: {
        response: {},
        excerptable: { type: Boolean },
        canRegenerate: { type: Boolean },
        wrapInAccordion: { type: Boolean, default: false },
        clipboardHeader: { default: "" }
    },
    emits: ["regenerate"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Setup
        const accordionTab = ref(0);
        let timeout = null;
        watch(accordionTab, async () => {
            await nextTick();
            if (timeout)
                clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.Ramius?.highlight?.drawMarkers?.();
            }, 500);
        });
        // Listen for excerpt mode changes from JSP
        const handleExcerptModeToggle = () => {
            if (props.wrapInAccordion) {
                accordionTab.value = 0;
            }
        };
        onMounted(() => {
            window.addEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        onUnmounted(() => {
            window.removeEventListener("loadExcerptPanel", handleExcerptModeToggle);
        });
        // Copy summary link functionality
        const isCopying = ref(false);
        const copySummaryLink = async () => {
            try {
                if (isCopying.value)
                    return;
                isCopying.value = true;
                // Get raw content from summary
                const rawContent = props.response.summary?.rawContent || props.response.summary?.content || "";
                // Use clipboard header if provided, otherwise just the content
                const summaryContent = (props.clipboardHeader || "") + rawContent;
                await navigator.clipboard.writeText(summaryContent);
                // Reset button state after 2 seconds
                setTimeout(() => {
                    isCopying.value = false;
                }, 2000);
            }
            catch (err) {
                console.error("Failed to copy summary:", err);
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = props.response.summary?.rawContent || props.response.summary?.content || "";
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                setTimeout(() => {
                    isCopying.value = false;
                }, 2000);
            }
        };
        const isRegenerating = ref(false);
        const regenerateSummary = () => {
            if (isRegenerating.value)
                return;
            isRegenerating.value = true;
            emit("regenerate");
            setTimeout(() => {
                isRegenerating.value = false;
            }, 3000);
        };
        return (_ctx, _cache) => {
            return (props.wrapInAccordion)
                ? (_openBlock(), _createBlock(RecAccordion, {
                    key: 0,
                    modelValue: accordionTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((accordionTab).value = $event)),
                    class: "conversation-accordion",
                    color: "ai-primary"
                }, {
                    "tab-0-header": _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Conversation Summary")), 1),
                            (_ctx.canRegenerate && _ctx.response.summary)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "conversation-accordion__button",
                                    onClick: _withModifiers(regenerateSummary, ["stop"])
                                }, [
                                    _createVNode(SvgIcon, {
                                        class: "rc-icon",
                                        src: "/svg/dropdown-icons.svg",
                                        icon: "icon-ai-regen"
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Regenerate")), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (props.excerptable && _ctx.response.summary)
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "conversation-accordion__button",
                                    "aria-label": _ctx.$t('Copy to clipboard'),
                                    onClick: _withModifiers(copySummaryLink, ["stop"]),
                                    onKeydown: [
                                        _withKeys(_withModifiers(copySummaryLink, ["stop"]), ["enter"]),
                                        _withKeys(_withModifiers(copySummaryLink, ["stop"]), ["space"])
                                    ]
                                }, [
                                    _createVNode(SvgIcon, { icon: "icon-copy" }),
                                    _createElementVNode("span", null, _toDisplayString(isCopying.value ? _ctx.$t("Copied") : _ctx.$t("Copy")), 1)
                                ], 40, _hoisted_2)), [
                                    [
                                        _unref(vTooltip),
                                        _ctx.$t('Copy to clipboard'),
                                        void 0,
                                        { hidePoint: true }
                                    ]
                                ])
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    "tab-0-content": _withCtx(() => [
                        _createVNode(SummaryContent, {
                            excerptable: props.excerptable,
                            response: _ctx.response
                        }, null, 8, ["excerptable", "response"])
                    ]),
                    _: 1
                }, 8, ["modelValue"]))
                : (_openBlock(), _createBlock(SummaryContent, {
                    key: 1,
                    excerptable: props.excerptable,
                    response: _ctx.response,
                    "show-expand-toggle": ""
                }, null, 8, ["excerptable", "response"]));
        };
    }
});
